import loader from "@/mixins/Loader";
import { mapActions } from "vuex";

export default {
  mixins: [loader],
  methods: {
    ...mapActions(['setLogout', 'deleteDefsData']),
    async logoutSession() {
      try {
        this.setLogout();
        this.deleteDefsData();
        await this.$router.push({ name: "Login" });
      } catch (e) {
        this.setLoader(false);
        console.error('[NODOS][deleteNode] ERROR:', e.response.status);
        return {
          response: {
            data: {
              errorCode: e.response.status,
            },
          },
        };
      }
    },
  },
};
